import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChallengeActivityQuery, ChallengeActivityQuestionAttemptService } from '@examdojo/challenge';
import { QuestionAttemptEntityService } from '@examdojo/question';
import { filter, forkJoin, of, switchMap } from 'rxjs';
import { ChallengeActivityQuestionSelectorService } from '../question-selector/challenge-activity-question-selector.service';

@Injectable()
export class FetchChallengeActivityQuestionAttemptsOnActiveService {
  constructor(
    private readonly challengeActivityQuery: ChallengeActivityQuery,
    private readonly challengeActivityQuestionAttemptService: ChallengeActivityQuestionAttemptService,
    private readonly challengeActivityQuestionSelectorService: ChallengeActivityQuestionSelectorService,
    private readonly questionAttemptEntityService: QuestionAttemptEntityService,
  ) {
    this.handleActiveChallengeActivity().pipe(takeUntilDestroyed()).subscribe();
  }

  private handleActiveChallengeActivity() {
    return this.fetchChallengeActivityQuestionAttemptsOnChallengeChange().pipe(
      switchMap(() => this.challengeActivityQuestionSelectorService.syncQuestionAttemptWithOngoingChallengeActivity()),
    );
  }

  private fetchChallengeActivityQuestionAttemptsOnChallengeChange() {
    return this.challengeActivityQuery.inProgressChallengeActivityId$.pipe(
      filter((challengeActivityId) => !!challengeActivityId),
      switchMap((challengeActivityId) => {
        if (!challengeActivityId) {
          return of(null);
        }

        this.questionAttemptEntityService.resetStore();

        return this.challengeActivityQuestionAttemptService
          .fetchByChallengeActivityId(challengeActivityId, {
            resetStore: true,
          })
          .pipe(
            switchMap((fetchedQuestionAttempts) => {
              if (!fetchedQuestionAttempts.length) {
                return of(null);
              }

              return forkJoin(
                fetchedQuestionAttempts.map((questionAttempt) =>
                  // TODO: refactor to bulk fetch instead of forkJoin
                  this.questionAttemptEntityService.fetchQuestionAttemptDetails(questionAttempt.question_attempt_id),
                ),
              );
            }),
          );
      }),
    );
  }
}
